(function () {
    'use strict';

    angular
        .module('partners')
        .controller('ReportsCareerAdvisorsListController', ReportsCareerAdvisorsListController);

    ReportsCareerAdvisorsListController.$inject = ['ReportsPartnersService', 'ExpoService', 'CitiesByExpoService', '$uibModal', '$q'];

    function ReportsCareerAdvisorsListController(ReportsPartnersService, ExpoService, CitiesByExpoService, $uibModal, $q) {
        var vm = this;

        vm.schools = [];

        vm.expos = [];
        vm.expoSelected = [];

        vm.cities = [];
        vm.citySelected = [];

        vm.loadExpos                 = loadExpos;
        vm.loadExpoCities            = loadExpoCities;
        vm.getByFilter               = getByFilter;
        vm.openRegisteredInformation = openRegisteredInformation;

        vm.flag                  = false;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.totalItems   = [];
        vm.currentPage  = null;
        vm.itemsPerPage = [];
        vm.page         = 1;


        activate();


        function setPage(page) {
            vm.currentPage = page;
        };


        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        };


        function activate() {
            vm.loadExpos();
        }


        function loadExpos() {
            vm.query = {};
            vm.query['alias'] = 'tsw';
            vm.query['from_year'] = 2017;

            ExpoService.getExposForSelect(vm.query).then(function(response) {
                vm.expos = response.data;
            }).catch(function(err) {
            });
        }


        function loadExpoCities() {
            CitiesByExpoService.getCities(vm.expoSelected.id).then(function(response){
                vm.cities = response.data.filter(function (city, i){
                    return city.is_high_school_road_show == 0;
                });
            }).catch(function(err) {

            });
        }


        function getByFilter() {
            vm.query = {};
            vm.query['expo_location_id'] = vm.citySelected.expos_locations_id;
            vm.query['career_advisors_report'] = true;
            vm.query['page'] = vm.page;

            vm.flag                     = false;

            ReportsPartnersService.getCareerAdvisorsReport(vm.query).then(function(response) {
                vm.flag = true;
                vm.schools = response.data.data;
                vm.totalItems = response.data.total;
                vm.itemsPerPage = response.data.per_page;
                vm.setPage(response.data.current_page);

            }).catch(function(err) {
            });
        }


        function openRegisteredInformation(partner) {
            $uibModal.open({
                templateUrl: 'templates/partners/show/registered.modal.html',
                controller: 'PartnerModalController',
                controllerAs:'vm',
                resolve: {
                    partner: function() {
                        return partner;
                    }
                }
            });
        }

    }
})();